import { GetterTree, ActionTree, MutationTree, ActionContext } from 'vuex';
import { Contact } from '@/models/contact.model';
import { cloneDeep } from 'lodash';

interface LoadingState {
  singleContact: Contact | null;
  singleContactIncludedArray: any[];
}

export const defaultSingleContactState: LoadingState = {
  singleContact: null,
  singleContactIncludedArray: []
};

const state: LoadingState = cloneDeep(defaultSingleContactState);

const mutations: MutationTree<LoadingState> = {
  ADD_SINGLE_CONTACT(returnedState: LoadingState, payload: { contact: Contact; includedArray: any[] }): void {
    returnedState.singleContact = payload.contact;
    returnedState.singleContactIncludedArray = payload.includedArray;
  },
  REMOVE_SINGLE_CONTACT(returnedState: LoadingState): void {
    returnedState.singleContact = null;
    returnedState.singleContactIncludedArray = [];
  }
};

const actions: ActionTree<LoadingState, {}> = {
  addContact: (
    { commit }: ActionContext<LoadingState, {}>,
    payload: { contact: Contact; includedArray: any[] }
  ): void => {
    commit('ADD_SINGLE_CONTACT', payload);
  },
  removeContact: ({ commit }: ActionContext<LoadingState, {}>): void => {
    commit('REMOVE_SINGLE_CONTACT');
  }
};

const getters: GetterTree<LoadingState, {}> = {
  singleContact: (returnedState: LoadingState): Contact | null => {
    return returnedState.singleContact;
  },
  contactFullName: ({ singleContact }: LoadingState): string | null => {
    if (!singleContact) {
      return null;
    }
    return `${singleContact.attributes.first_name} ${singleContact.attributes.last_name}`;
  },
  singleContactIncludedArray: (returnedState: LoadingState): any[] => {
    return returnedState.singleContactIncludedArray;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
